import * as React from 'react';
import { servicesAtom } from '../stores';
import useFetch from './useFetch';
import { useAtom } from 'jotai';
export function useFetchNotes() {
    var _a = useAtom(servicesAtom), services = _a[0], setServices = _a[1];
    var _b = useFetch(), noteState = _b[0], fetchNotes = _b[1];
    var fetchNotesHandler = function (serviceId) {
        fetchNotes.go("/api/v1/account/services/notes?serviceId=".concat(serviceId), 'GET');
    };
    React.useEffect(function () {
        if (noteState.success) {
            services.notes = noteState.data.notes;
            setServices(services);
            fetchNotes.reset();
        }
        if (noteState.error) {
            fetchNotes.reset();
        }
    }, [noteState]);
    return fetchNotesHandler;
}
